import { GtmCarouselClickType } from '~/modules/analytics/gtmEventTypes/gtmCarouselClickType';
import { GtmHeaderNavLinkClickType } from '~/modules/analytics/gtmEventTypes/gtmHeaderNavLinkClickType';
import { GtmSortClickType } from '~/modules/analytics/gtmEventTypes/gtmSortClickType';
import { GtmTryButtonClickType } from '~/modules/analytics/gtmEventTypes/gtmTryButtonClickType';
import { GtmButtonClickType } from './gtmButtonClickType';
import { GtmCustomExperimentType } from './gtmCustomExperimentType';
import { GtmEventType } from './gtmEventType';
import { GtmFilterClickType } from './gtmFilterClickType';
import { GtmFilterSearchType } from './gtmFilterSearchType';
import { GtmLinkClickType } from './gtmLinkClickType';
import { GtmListingDetailClickType } from './gtmListingDetailClickType';
import { GtmLoginNavClickType } from './gtmLoginNavClickType';
import { GtmLoginType } from './gtmLoginType';
import { GtmNavLinkClickType } from './gtmNavLinkClickType';
import { GtmPageLevelType } from './gtmPageLevelType';
import { GtmSearchClickType } from './gtmSearchClickType';
import { GtmSearchType } from './gtmSearchType';
import { GtmSignupType } from './gtmSignupType';
import { GtmTileClickType } from './gtmTileClickType';
import { GtmTileViewType } from './gtmTileViewType';

export class GtmEventTypeFactory {
    gtmHandlers: GtmEventType[] = [
        new GtmTileViewType(),
        new GtmTileClickType(),
        new GtmButtonClickType(),
        new GtmPageLevelType(),
        new GtmHeaderNavLinkClickType(),
        new GtmNavLinkClickType(),
        new GtmLinkClickType(),
        new GtmLoginType(),
        new GtmSignupType(),
        new GtmLoginNavClickType(),
        new GtmCustomExperimentType(),
        new GtmListingDetailClickType(),
        new GtmFilterClickType(),
        new GtmSearchType(),
        new GtmSearchClickType(),
        new GtmFilterSearchType(),
        new GtmSortClickType(),
        new GtmTryButtonClickType(),
        new GtmCarouselClickType(),
    ];

    // @ts-expect-error * Automated Type Error Fix
    getEventTypeHandler(event): GtmEventType {
        // @ts-expect-error * Automated Type Error Fix
        return this.gtmHandlers.find((handler) => handler.canHandle(event));
    }
}
